import { url } from '@/config'; // var request = window.axios;

import request from '@/router/axios';
export var getList = function getList(params) {
  return request({
    url: url + '/map/list',
    method: 'get',
    params: params
  });
};
export var getObj = function getObj(id) {
  return request({
    url: url + '/map/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var addObj = function addObj(data) {
  return request({
    url: url + '/map/save',
    method: 'post',
    data: data
  });
};
export var updateObj = function updateObj(data) {
  return request({
    url: url + '/map/update',
    method: 'post',
    data: data
  });
};
export var delObj = function delObj(id) {
  return request({
    url: url + '/map/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};